var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.66699L1.33333 17.5003H19.6667M10.5 5.00033L16.775 15.8337H4.22499M9.66666 8.33366V11.667H11.3333V8.33366M9.66666 13.3337V15.0003H11.3333V13.3337",
    fill: "#313131"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_warning.b2c15f7a06e1fb51bddde2f7c17ca460.svg";